import config from 'utils/config';

// CSS for this component is provided by index.css.
// This markup should be identical to the preloader in index.html. Vite prefixes that one's src
// with the base path (a PR preview is served under /<PR number>/); here it is done by hand.
const PageLoader = () => {
  return (
    <div className="preloader-container" data-testid="page-loader">
      <div className="preloader">
        <div />
        <div />
        <div />
        <div />

        <img
          src={`${config.pathBasename ?? ''}/favicon.svg`}
          width="75"
          height="75"
          alt="Carro"
          style={{ borderRadius: '12px' }}
        />
      </div>
    </div>
  );
};

export default PageLoader;
